module.exports = __webpack_public_path__ + "nyckelhal_farg-030b4c7119ea17a3394bf2075d75f51e.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/product-labels/nyckelhal_farg.png
// module id = 90
// module chunks = 0